import { render, staticRenderFns } from "./PackageHistoryList.vue?vue&type=template&id=f8f17350&scoped=true&"
import script from "./PackageHistoryList.vue?vue&type=script&lang=js&"
export * from "./PackageHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f17350",
  null
  
)

export default component.exports